module.exports = {
  theme: {
    screens: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      'max-lg': { max: '1024px' },
      xl: '1280px',
      '2xl': '1440px',
    },
    extend: {
      colors: {
        'gb-red': '#F95525',
        'gb-red-dark': '#E04C21',
        'gb-magenta': '#FF4DC2',
        'gb-magenta-dark': '#FE00A7',
        'gb-blue': '#19179C',
        'gb-blue-dark': '#14127C',
        'gb-cream': '#EEE8DA',
        'gb-cream-dark': '#E8E0CD',
      },
      fontFamily: {
        domaine: ['Domaine Text', 'serif'],
        object: ['PP Object Sans', 'sans-serif'],
        'object-light': ['PP Object Sans Light', 'sans-serif'],
      },
    },
  },
}
